import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogActions, DialogContent, Button,
} from '@mui/material';

import TimeRangeSelector from './time-range-selector';

class TimeRangeDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      time: [],
    };

    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleDateSave = this.handleDateSave.bind(this);
  }

  handleClickOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleTimeChange(time) {
    const startTime = time && time[0];
    const endTime = time && time[1];

    if (startTime && endTime) {
      const newState = {
        time,
      };
      this.setState(newState);
    }
  }

  handleDateSave() {
    const { handleTimeChange } = this.props;
    const { time } = this.state;

    const start = time[0];
    const end = time[1];

    if (start && end) {
      handleTimeChange(time);
      this.handleClose();
    }
  }

  render() {
    const { isOpen, time } = this.state;

    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Choose Times
        </Button>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <TimeRangeSelector
              time={time}
              onChange={this.handleTimeChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              Close
            </Button>
            <Button onClick={this.handleDateSave} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TimeRangeDialog.propTypes = {
  handleTimeChange: PropTypes.func.isRequired,
};

export default TimeRangeDialog;
